import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import lodash from "lodash";

import Instructors from "../Instructors";
import SignUp from "./SignUp";
import { DATETIME, TIME } from "../../../utils/dateFormats";

const Item = ({ isAdmin, currentUserId, data, onSignedUp }) => {
  const signedUp = data['signed_up?'];
  const disableSignUp =
    (data.allow_sign_ups && signedUp) ||
    (data.class_limit && data.in_service_users.length >= data.class_limit);

  return (
    <tr>
      <td>{data.location ? data.location.name : "No Location Specified"}</td>
      <td>
        {moment(data.start_time).format(DATETIME)}
        {" - "}
        {moment(data.end_time).format(TIME)}
      </td>
      <td><Instructors users={data.instructors}/></td>
      <td>{data.topic}</td>
      <td className="text-right">
        {(!data.allow_sign_ups) ? null : <SignUp id={data.id} disabled={disableSignUp} isSignedUp={signedUp} onDone={onSignedUp}/>}

        {isAdmin ? (
          <a
            className="btn btn-text"
            href={`/in_services/${data.id}/edit`}
          >
            EDIT
          </a>
        ) : null}

        {signedUp || isAdmin ? (
          <a
            className={"btn btn-text"}
            href={`/in_services/${data.id}`}
          >
            VIEW
          </a>
        ) : null}
      </td>
    </tr>
  );
};

Item.propTypes = {
  isAdmin: PropTypes.bool.isRequired,
  currentUserId: PropTypes.number.isRequired,
  data: PropTypes.object.isRequired,
  onSignedUp: PropTypes.func.isRequired
};

export default Item;
